module.exports = __webpack_public_path__ + "img/product_heading1_pc.445efac0.png";